(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__announcementTooltipsInit) return;
    window.__announcementTooltipsInit = true;

    function onDocClick(e) {
      var trigger = e.target.closest('.announcement-bar__tooltip-trigger');
      if (trigger) {
        var group = trigger.closest('.announcement-bar__tooltip-group');
        if (group) {
          var isVisible = group.classList.toggle('announcement-bar__tooltip-visible');
          trigger.setAttribute('aria-expanded', isVisible);
        }
        return;
      }
      document.querySelectorAll('.announcement-bar__tooltip-group.announcement-bar__tooltip-visible').forEach(function (group) {
        group.classList.remove('announcement-bar__tooltip-visible');
        var t = group.querySelector('.announcement-bar__tooltip-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        document.addEventListener('click', onDocClick);
      });
    } else {
      document.addEventListener('click', onDocClick);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_nw-product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    class ProductReferenceCopy extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-product-reference-copy]');
        this.status = this.querySelector('[data-product-reference-copy-status]');
        this.resetTimeout = null;

        if (!(this.button instanceof HTMLButtonElement)) return;

        this.handleCopy = this.handleCopy.bind(this);
        this.button.addEventListener('click', this.handleCopy);
      }

      disconnectedCallback() {
        if (this.button instanceof HTMLButtonElement && this.handleCopy) {
          this.button.removeEventListener('click', this.handleCopy);
        }

        window.clearTimeout(this.resetTimeout);
      }

      async copyText(text) {
        if (!text) return false;

        if (navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(text);
            return true;
          } catch (_error) {
            // Continue with the legacy fallback when the Clipboard API is unavailable or denied.
          }
        }

        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();

        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (_error) {
          copied = false;
        }

        textArea.remove();
        return copied;
      }

      async handleCopy() {
        if (!(this.button instanceof HTMLButtonElement)) return;

        this.button.disabled = true;
        const copied = await this.copyText(this.button.dataset.copyText || '');
        this.button.disabled = false;

        if (this.status instanceof HTMLElement) {
          this.status.textContent = copied ? this.dataset.copiedLabel || '' : this.dataset.copyFailedLabel || '';
        }

        window.clearTimeout(this.resetTimeout);

        if (!copied) return;

        this.button.dataset.copyState = 'copied';
        this.resetTimeout = window.setTimeout(() => {
          if (this.button instanceof HTMLButtonElement) {
            delete this.button.dataset.copyState;
          }
          if (this.status instanceof HTMLElement) this.status.textContent = '';
        }, 1800);
      }
    }

    if (!customElements.get('product-reference-copy')) {
      customElements.define('product-reference-copy', ProductReferenceCopy);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const gridSelector = '.js-plp-grid';
    const toggleSelector = '.js-toggle-filter-column';
    const storageKey = 'disfrazzes:filters:desktop-pane-visible';
    // Keep in sync with the CSS media query that hides the column on landscape phones.
    const drawerQuery = window.matchMedia('(min-width: 750px) and (hover: none) and (pointer: coarse) and (max-height: 500px)');

    if (!window.filterColumnToggleController) {
      window.filterColumnToggleController = {};
    }

    const readStoredFilterColumnState = () => {
      try {
        const value = window.sessionStorage.getItem(storageKey);

        if (value === 'true') return true;
        if (value === 'false') return false;
      } catch (error) {
        return null;
      }

      return null;
    };

    const writeStoredFilterColumnState = (isExpanded) => {
      try {
        window.sessionStorage.setItem(storageKey, String(isExpanded));
      } catch (error) {
        return;
      }
    };

    // Fallback a /search: no restaurar sessionStorage ni abrir la columna.
    // tw:md:block !important gana a la clase .hidden; si se quita el atributo
    // [hidden], el panel reaparece.
    const isFiltersSearchFallback = (button) => button.hasAttribute('data-filters-search-fallback');

    const restoreStoredFilterColumnState = (button) => {
      if (isFiltersSearchFallback(button)) return;

      const storedState = readStoredFilterColumnState();

      if (storedState === null) return;

      button.setAttribute('aria-expanded', String(storedState));
    };

    const syncFilterColumnState = (button) => {
      const columnId = button.getAttribute('aria-controls');
      const column = columnId ? document.getElementById(columnId) : null;

      if (!column) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const toggleText = button.querySelector('.js-toggle-filter-column-text');
      const grid = document.querySelector(gridSelector);

      column.hidden = !isExpanded;
      document.documentElement.classList.toggle('filters-column-session-hidden', !isExpanded);

      // Only when it changes: this also runs on load, and rewriting the same text restyles the whole section.
      const label = isExpanded ? button.dataset.hideLabel : button.dataset.showLabel;
      if (toggleText && toggleText.textContent.trim() !== label) {
        toggleText.textContent = label;
      }

      if (!grid) return;

      if (isExpanded) {
        grid.style.removeProperty('min-width');
      } else {
        grid.style.minWidth = '100%';
      }
    };

    const restoreAllStoredFilterColumnStates = () => {
      document.querySelectorAll(toggleSelector).forEach(restoreStoredFilterColumnState);
    };

    const syncAllFilterColumns = () => {
      document.querySelectorAll(toggleSelector).forEach(syncFilterColumnState);
    };

    window.filterColumnToggleController.sync = syncAllFilterColumns;

    if (window.filterColumnToggleController.initialized) {
      restoreAllStoredFilterColumnStates();
      syncAllFilterColumns();
      return;
    }

    window.filterColumnToggleController.initialized = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest(toggleSelector);

      if (!button) return;

      // Landscape phones: the column is hidden by CSS, so the button opens the drawer (the stored desktop state
      // is left untouched).
      if (drawerQuery.matches) {
        document.getElementById('filters-drawer')?.showDialog?.();
        return;
      }

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const nextIsExpanded = !isExpanded;

      button.setAttribute('aria-expanded', String(nextIsExpanded));
      writeStoredFilterColumnState(nextIsExpanded);
      syncFilterColumnState(button);
    });

    document.addEventListener('DOMContentLoaded', () => {
      restoreAllStoredFilterColumnStates();
      syncAllFilterColumns();
    });

    document.addEventListener('shopify:section:load', () => {
      restoreAllStoredFilterColumnStates();
      syncAllFilterColumns();
    });


    restoreAllStoredFilterColumnStates();
    syncAllFilterColumns();
  })();
  } catch(e) { console.error(e); }
})();

})();
